import { render, staticRenderFns } from "./performance-template-create.vue?vue&type=template&id=6982c3c6"
import script from "./performance-template-create.vue?vue&type=script&lang=js"
export * from "./performance-template-create.vue?vue&type=script&lang=js"
import style0 from "./performance-template-create.vue?vue&type=style&index=0&id=6982c3c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports